import { Trans } from '@lingui/react'
import { number, objectOf, shape, string } from 'prop-types'
import { PureComponent } from 'react'

import { TYPE_SEARCH_NO_RESULTS } from 'shared/consts/crosssellWidgets'
import Button from 'views/components/atoms/Button'
import HotlineHours from 'views/components/atoms/HotlineHours'
import OnPageSearchForm from 'views/components/molecules/OnPageSearchForm'
import SellerModal from 'views/components/organisms/SellerModal'
import { CROSSSELL_ITEMS_OVERALL_COUNT_HUGE } from 'views/consts/sliders'
import CrosssellSliderHorizontal from 'views/containers/crosssell/CrosssellSliderHorizontal'
import withMountPoints from 'views/enhancers/withMountPoints'
import { mountPointsType } from 'views/utils/propTypes'
import './SearchNoResults.scss'

class SearchNoResults extends PureComponent {
  static propTypes = {
    query: string.isRequired,
    crossSellWidgets: objectOf(number).isRequired,
    shopConfig: shape({
      contact: shape({
        phoneNumber: string.isRequired,
      }).isRequired,
      crosssell: shape({
        widgets: objectOf(number),
      }).isRequired,
    }).isRequired,
    mountPoints: mountPointsType.isRequired,
  }

  render() {
    const {
      query,
      shopConfig: {
        contact: { phoneNumber },
        crosssell: { widgets: crossSellWidgets },
      },
      mountPoints,
    } = this.props

    return (
      <>
        <h1 className="o-SearchNoResults__title">
          <Trans id="searchResults.empty.title" />
        </h1>
        <div className="l-grid u-margin--bottom">
          <div className="l-grid__item l-col--7-of-12@medium o-SearchNoResults__container">
            <div className="a-box a-box--bordered a-box--no-rounded-corners o-SearchNoResults__box">
              <p className="o-SearchNoResults__title o-SearchNoResults__box__text">
                <Trans
                  id="searchResults.empty.noMatchesForQuery"
                  components={{
                    0: (
                      <q className="u-color--blue u-font-weight--bold o-SearchNoResults__link">
                        {query}
                      </q>
                    ),
                  }}
                />
              </p>
              <p className="o-SearchNoResults__box__text">
                <Trans id="searchResults.empty.formLabel" />
              </p>
              <OnPageSearchForm
                className="u-margin--bottom"
                query={this.props.query}
              />
              <div className="o-SearchNoResults__faq-container">
                <Trans
                  id="searchResults.empty.faqPrompt"
                  components={{
                    /* eslint-disable jsx-a11y/anchor-has-content */
                    0: <a href={mountPoints.getFaqSearch()} />,
                    1: <a href={mountPoints.getFaq()} />,
                    /* eslint-enable jsx-a11y/anchor-has-content */
                  }}
                />
              </div>
            </div>
          </div>
          <div className="l-grid__item l-col--5-of-12@medium o-SearchNoResults__container">
            <div className="a-box a-box--bordered a-box--no-rounded-corners o-SearchNoResults__box">
              {/*
                FIXME This ridiculous div is needed, because GTM script
                is removing second parent here to hide the hotline.
                Unwrap when we’ll be getting rid of that
              */}
              <div>
                <Trans
                  id="searchResults.empty.contact.prompt"
                  components={{
                    0: (
                      <p className="u-no-margin o-SearchNoResults__title .o-SearchNoResults__text-item" />
                    ),
                    1: (
                      <p className="o-SearchNoResults__text o-SearchNoResults__text-item" />
                    ),
                  }}
                />
              </div>
              <p>
                <Trans
                  id="searchResults.empty.contact.hotline"
                  components={{
                    0: (
                      <HotlineHours
                        itemWrapper={
                          <strong className="u-display--inline-block u-color--blue" />
                        }
                      />
                    ),
                    1: (
                      <strong className="u-display--inline-block u-color--blue">
                        {phoneNumber}
                      </strong>
                    ),
                  }}
                />
              </p>
              <p className="o-SearchNoResults__link-container o-SearchNoResults__text-item o-SearchNoResults__box__text">
                <Button
                  href={mountPoints.getContact()}
                  name="contact-form"
                  inline
                >
                  <Trans id="general.label.contactForm" />
                </Button>
              </p>
            </div>
          </div>
        </div>
        <div className="o-NoResultsSliderWrapper">
          <CrosssellSliderHorizontal
            wid={crossSellWidgets[TYPE_SEARCH_NO_RESULTS]}
            csize={CROSSSELL_ITEMS_OVERALL_COUNT_HUGE}
          />
        </div>
        <SellerModal />
      </>
    )
  }
}

export default withMountPoints(SearchNoResults)
